export default {
  "content": "<path fill=\"none\" d=\"M0 0h48v48H0z\"/><path fill=\"#d7d8de\" d=\"M1 41h46v3.99H1z\"/><circle cx=\"41.5\" cy=\"33.5\" r=\"1.5\" fill=\"#3f4450\"/><g fill=\"none\" stroke=\"#3f4450\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M39 21h8V44.99H1V21h8\"/><path d=\"M9 26V4h30v22M6 26h36M1 41h46M30 25.98V14M24.01 26V9M18 26V9\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 48 48"
  }
};